<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" title="发票信息" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div>
			<el-form ref="formRef" :model="form" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="发票类型：" prop="invoiceType">
							<span class="invoice-info">{{ form.invoiceType === 1 ? '个人' : '企业' }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				
				<div v-if="form.invoiceType === 1">
					<el-row :gutter="20">
						<el-col :span="11">
							<el-form-item label="备注信息：" prop="brief" >
								<span class="invoice-info">{{ form.brief || '无' }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="form.invoiceType === 2">
					<el-row :gutter="20">
						<el-col :span="11">
							<el-form-item label="发票抬头：" prop="invoiceTitle" >
								<span class="invoice-info">{{ form.invoiceTitle }}</span>
							</el-form-item>
						</el-col>

						<el-col :offset="1" :span="11">
							<el-form-item label="纳税人识别号：" prop="taxNumber" >
								<span class="invoice-info">{{ form.taxNumber }}</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="11">
							<el-form-item label="开户银行：" prop="bankName" >
								<span class="invoice-info">{{ form.bankName }}</span>
							</el-form-item>
						</el-col>

						<el-col :offset="1" :span="11">
							<el-form-item label="银行账号：" prop="bankAccount" >
								<span class="invoice-info">{{ form.bankAccount }}</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="11">
							<el-form-item label="公司地址：" prop="companyAddress" >
								<span class="invoice-info">{{ form.companyAddress }}</span>
							</el-form-item>
						</el-col>

						<el-col :offset="1" :span="11">
							<el-form-item label="公司电话：" prop="companyPhone" >
								<span class="invoice-info">{{ form.companyPhone }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<!-- <el-button size="small" @click="handleClose">关闭</el-button> -->
			</div>
		</template>
	</el-dialog>
</template>

<script>
export default {
	name: 'DialogInvoiceInfo',
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		form: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	 //line-height: 26px;
}

.invoice-info {
	display: inline-block;
	line-height: 24px;
}
</style>
